import { Link } from "@tanstack/react-router";
import { useTranslation } from "../../i18n";

export function HomeAnnouncement() {
  const { t } = useTranslation();
  return <aside className={`home-announcement
  flex items-center justify-center gap-6 [min-height:63px] [padding:20px_32px] [background:linear-gradient(115deg,#285ea5,#57569b_55%,#2878b0)] [color:#fff] [font-size:14px] [line-height:1.6]
  [&_p]:m-0 [&_p]:text-center
  maxw-[1100px]:flex-wrap maxw-[1100px]:[gap:8px_20px] maxw-[1100px]:px-6
  maxw-[480px]:[padding:20px_16px] maxw-[480px]:[font-size:12px]
`} aria-label={t("creativeHome.announcement.label")}>
    <p>{t("creativeHome.announcement.message")}</p>
    <div className="flex shrink-0 items-center justify-center gap-5">
      <Link to="/about-nexra" className="underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-4">{t("creativeHome.announcement.about")}</Link>
      <Link to="/contact" className="underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-4">{t("creativeHome.announcement.contact")}</Link>
    </div>
  </aside>;
}
